import axios from 'axios'
import { baseUrl } from '@/http/api.js'

export default {
  // 用户注册
  register (params) {
    return axios.post(baseUrl + '/api/register', params)
  },
  // 获取验证码
  getCode (params) {
    return axios.get(baseUrl + '/mobile/code', {
      params: params
    })
  },
  // 用户登录
  login (params) {
    return axios.post(baseUrl + '/api/login', params)
  },
  // 个人中心
  custmerCenter (params) {
    return axios.get(baseUrl + '/api/custmer/center', {
      params: params
    })
  },
  // 淘宝app流量发布
  tbAppTODO (params) {
    return axios.post(baseUrl + '/api/publish/taobao/app', params)
  },
  publishTaobao (params) {
    return axios.post(baseUrl + '/api/publish/taobao/app', params)
  },
  // 淘宝搜索收藏发布
  tbCollect (params) {
    return axios.post(baseUrl + '/api/publish/taobao/collect', params)
  },
  // 淘宝搜索加购发布
  tbSearchCart (params) {
    return axios.post(baseUrl + '/api/publish/taobao/search/cart', params)
  },
  tbCart (params) {
    return axios.post(baseUrl + '/api/publish/taobao/cart', params)
  },
  // 淘宝appPc流量发布
  tbPc (params) {
    return axios.post(baseUrl + '/api/publish/taobao/pc', params)
  },
  // 淘宝appLike流量发布
  tbLike (params) {
    return axios.post(baseUrl + '/api/publish/taobao/like', params)
  },
  // 淘宝app口令流量发布
  tbPwd (params) {
    return axios.post(baseUrl + '/api/publish/taobao/pwd', params)
  },
  // 淘宝聚划算
  taobaoHot (params) {
    return axios.post(baseUrl + '/api/publish/taobao/hot', params)
  },
  // 淘宝达人关注
  taobaoLive (params) {
    return axios.post(baseUrl + '/api/publish/taobao/live', params)
  },
  // 商品价格列表
  goodsConfigList (params) {
    return axios.get(baseUrl + '/api/goodsConfig/list', {
      params: params
    })
  },
  // 订单创建
  orderCreate (params) {
    return axios.post(baseUrl + '/api/order/create', params)
  },
  // 订单支付
  orderPay (params) {
    return axios.get(baseUrl + '/api/order/pay', {
      params: params
    })
  },
  // 获取订单id
  getOrderId (params) {
    return axios.get(baseUrl + '/api/order/id', {
      params: params
    })
  },
  // 京东app发布
  jingdongApp (params) {
    return axios.post(baseUrl + '/api/publish/jingdong/app', params)
  },
  // 获取京东标题
  jingdongTitle (params) {
    return axios.get(baseUrl + '/api/title', {params: params})
  },
  // 京东店铺收藏发布
  jingdongShop (params) {
    return axios.post(baseUrl + '/api/publish/jingdong/shop', params)
  },
  // 京东搜索加购发布
  jingdongSearchCart (params) {
    return axios.post(baseUrl + '/api/publish/jingdong/cart', params)
  },
  // 京东搜索加购发布
  jdCollect (params) {
    return axios.post(baseUrl + '/api/publish/jingdong/collect', params)
  },
  // 拼多多app发布
  pinduoduoApp (params) {
    return axios.post(baseUrl + '/api/publish/pinduoduo/app', params)
  },
  // 获取拼多多标题
  pinddTitle (params) {
    return axios.post(baseUrl + '/api/pdd/title', params)
  },
  // 拼多多店铺收藏发布
  pinduoduoShopCollect (params) {
    return axios.post(baseUrl + '/api/publish/pinduoduo/shop/collect', params)
  },
  // 拼多多搜索收藏/直接收藏/店铺收藏
  pddCollect (params) {
    return axios.post(baseUrl + '/api/publish/pinduoduo/collect', params)
  },
  // 任务列表
  taskList (params) {
    return axios.post(baseUrl + '/api/task/list', params)
  },
  // 流量明细
  countList (params) {
    return axios.post(baseUrl + '/api/task/count', params)
  },
  // 取消任务
  cancelTask (params) {
    return axios.post(baseUrl + '/api/cancel/task', params)
  },
  // 保存模板
  saveTemplate (params) {
    return axios.post(baseUrl + '/api/task/saveTemplate', params)
  },
  // 模板查询
  templateList (params) {
    return axios.post(baseUrl + '/api/template/list', params)
  },
  // 模板删除
  templateDel (params) {
    return axios.post(baseUrl + '/api/template/del', params)
  },
  // 检测权重池用户信息
  qzcLogin (params) {
    return axios.post(baseUrl + '/api/check/qzc/login', params)
  },
  // 二维码
  qrcode (params) {
    return axios.get(baseUrl + '/api/qrcode/id', {
      params: params
    })
  },
  // 修改密码
  updatePwd (params) {
    return axios.post(baseUrl + '/api/custmer/update/pwd', params)
  },
  // 旺旺打标
  wangwang (params) {
    return axios.post(baseUrl + '/api/publish/taobao/wangwang', params)
  },
  // 宝贝点赞
  support (params) {
    return axios.post(baseUrl + '/api/publish/taobao/support', params)
  },
  taobaoRecommend (params) {
    return axios.post(baseUrl + '/api/publish/taobao/recommend', params)
  },
  // 每日好店
  goodShop (params) {
    return axios.post(baseUrl + '/api/publish/taobao/good/shop', params)
  },
  // 淘宝商品收藏
  goodCollect (params) {
    return axios.post(baseUrl + '/api/publish/taobao/good/collect', params)
  },
  // 淘宝店铺收藏
  tbShopCollect (params) {
    return axios.post(baseUrl + '/api/publish/taobao/shop/collect', params)
  },
  // 用户商品id
  custmerGoods (params) {
    return axios.get(baseUrl + '/api/custmer/goods', {
      params: params
    })
  },
  // 淘口令解析
  pwdInfo (params) {
    return axios.get('http://www.quanzhongchi365.com/quanzhongchi' + '/api/tao/pwd/info', {
      params: params
    })
  },
  // 淘口令解析
  apiTaobaoInfo (params) {
    return axios.get(baseUrl + '/api/taobao/pwd', {
      params: params
    })
  },
  // 获取商品标题
  newGetgoodsTitle (params) {
    return axios.get('http://www.quanzhongchi365.com/quanzhongchi' + '/api/common/good/info', {
      params: params
    })
  },
  // 逛逛点赞
  guangguang (params) {
    return axios.post(baseUrl + '/api/publish/taobao/look', params)
  },
  // 抖音关注
  douyinFollow (params) {
    return axios.post(baseUrl + '/api/publish/douyin/follow', params)
  },
  // 抖音点赞
  douyinAdd (params) {
    return axios.post(baseUrl + '/api/publish/douyin/add', params)
  },
  // 抖音点赞
  douyinPlay (params) {
    return axios.post(baseUrl + '/api/publish/douyin/play', params)
  }
}



// WEBPACK FOOTER //
// ./src/axios.js